import { createReducer, on } from '@ngrx/store';
import * as GuestsActions from './guests.actions';
import { initialGuestsState } from './guests.state';

export const guestsReducer = createReducer(
  initialGuestsState,

  on(GuestsActions.loadGuests, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(GuestsActions.loadGuestsSuccess, (state, { guests, pagination }) => ({
    ...state,
    guests,
    pagination,
    loading: false,
    error: null,
  })),

  on(GuestsActions.loadGuestsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(GuestsActions.createGuest, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(GuestsActions.createGuestSuccess, (state, { guest }) => ({
    ...state,
    guests: [ ...state.guests, guest ],
    loading: false,
    error: null,
  })),

  on(GuestsActions.createGuestFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(GuestsActions.updateGuest, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(GuestsActions.updateGuestSuccess, (state, { guest }) => ({
    ...state,
    guests: state.guests.map(g => g.id === guest.id ? guest : g),
    loading: false,
    error: null,
  })),

  on(GuestsActions.updateGuestFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(GuestsActions.deleteGuest, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(GuestsActions.deleteGuestSuccess, (state, { id }) => ({
    ...state,
    guests: state.guests.filter(g => g.id !== id),
    loading: false,
    error: null,
  })),

  on(GuestsActions.deleteGuestFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(GuestsActions.uploadGuestPhoto, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(GuestsActions.uploadGuestPhotoSuccess, (state, { guest }) => ({
    ...state,
    guests: state.guests.map(g => g.id === guest.id ? guest : g),
    loading: false,
    error: null,
  })),

  on(GuestsActions.uploadGuestPhotoFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(GuestsActions.deleteGuestPhoto, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(GuestsActions.deleteGuestPhotoSuccess, (state, { guest }) => ({
    ...state,
    guests: state.guests.map(g => g.id === guest.id ? guest : g),
    loading: false,
    error: null,
  })),

  on(GuestsActions.deleteGuestPhotoFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);
